
import Vue from "vue";
import dialogCom from "@/components/ModelCom.vue";
import CookieUtil from "@/assets/js/CookieUtil";
import { cookieTypes } from "@/assets/js/Types";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
export default Vue.extend({
  props: ["title"],
  components: { dialogCom },
  data() {
    return {
      action: 0,
    };
  },
  mounted() {
    //
  },
  methods: {
    open() {
      const dialog: any = this.$refs.fileDialog;
      dialog.show();
    },
    hiden() {
      const dialog: any = this.$refs.fileDialog;
      dialog.hiden();
    },
    async exportData() {
      this.$emit("manualCharge", this.action);
    },
  },
});
